import { call, takeLatest, takeEvery, debounce, all, takeLeading, take, put, fork, cancel, delay, cancelled } from 'redux-saga/effects';
import axios from 'axios';
import { isFunc } from '@utils/functions';
import config from "@config";
import { eventChannel } from "redux-saga";
import { actionTypes as journeysActionTypes } from '../reducers';

let shouldUpdatedJourneysObserverBeTerminated = true;
let wsUpdatedJourneysObserver;

let shouldScorecardObserverBeTerminated = true;
let wsScorecardObserver;

let shouldContractObserverBeTerminated = true;
let wsContractObserver;

const Api = {
  getJourneys: ({ userId, sort, limit, statuses }) => {
    let params = {
      limit: limit ?? 100
    };
    if (userId) params.user = userId;
    if (sort) params.sort = sort;
    if (statuses) params.statuses = statuses;

    return axios.request({
      url: '/journeys',
      method: 'get',
      params
    });

  },
  getAllowedJourneys: ({ limit, page, userId, search, sort, milestone, milestones, types, currentStepUid, currentStepUids, specialist, settlementsCoordinator, referredBy, account, reference, createdLastDays, updatedLastDays, statuses, invitedByUser, withTotalFormallyApprovalAmount, requestFromPartner, activities, activityFromDate, activityToDate, journeyId, allAtOnce, signal }) => {
    let params = {
      limit: limit ?? 10
    };
    if (userId) params.user = userId;
    if (search) params.search = search;
    if (sort) params.sort = sort;
    if (milestone) params.milestone = milestone;
    if (currentStepUid) params.currentStepUid = currentStepUid;
    if (currentStepUids) params.currentStepUids = currentStepUids;
    if (specialist) params.specialist = specialist;
    if (settlementsCoordinator) params.settlementsCoordinator = settlementsCoordinator;
    if (referredBy) params.referredBy = referredBy;
    if (account) params.account = account;
    if (reference) params.reference = reference;
    if (page || page === 0) params.page = page;
    if (createdLastDays) params.createdLastDays = createdLastDays;
    if (updatedLastDays) params.updatedLastDays = updatedLastDays;
    if (statuses) params.statuses = statuses;
    if (invitedByUser) params.invitedByUser = invitedByUser;
    if (withTotalFormallyApprovalAmount) params.withTotalFormallyApprovalAmount = withTotalFormallyApprovalAmount;
    if (requestFromPartner) params.requestFromPartner = requestFromPartner;
    if (!!activities) params.activities = 'true';
    if (!!allAtOnce) params.allAtOnce = 'true';
    if (activityFromDate) params.activityFromDate = activityFromDate;
    if (activityToDate) params.activityToDate = activityToDate;
    if (journeyId) params.journeyId = journeyId;
    if (milestones?.length) params.milestones = milestones;
    if (types?.length) params.types = types;

    return axios.request({
      url: '/allowedJourneys',
      method: 'get',
      params,
      signal
    });
  },
  getJourney: (id) => axios.get(`/journeys/${id}`),
  getAllowedJourney: (id) => axios.get(`/allowedJourney/${id}`),
  updateJourney: ({id, body, notify, stepId, milestone, section, substatusNameStatus, metaAddress, metaDuration, metaValuationAmount}) => {
    let params = {};
    if (notify === 'yes') {
      params.notify = notify;
      if (stepId) params.stepId = stepId;
      if (milestone) params.milestone = milestone;
      if (section) params.section = section;
      if (substatusNameStatus) params.substatusNameStatus = substatusNameStatus;
      if (metaAddress) params.metaAddress = metaAddress;
      if (metaDuration) params.metaDuration = metaDuration;
      if (metaValuationAmount) params.metaValuationAmount = metaValuationAmount;
    }

    return axios.request({
      url: `/journeys/${id}`,
      method: 'put',
      data: body,
      params
    });
  },
  goNextJourneyStep: ({id, category, command, applicantId, notify}) => {
    let params = {};
    if (applicantId) params.applicant = applicantId;
    if (command) params.command = command;
    if (notify) params.notify = notify;

    return axios.request({
      url: `journeys/${id}/next/${category}`,
      method: 'post',
      params,
      data: {}
    });
  },
  rollbackJourneyStep: ({ journeyId, category, stepId, skipConditional }) => axios.post(`/journeys/${journeyId}/rollback/${category}/${stepId}`, { skipConditional }),
  getBorrowingCapacity: ({ journeyId, applicantId }) => axios.get(`/services/borrowingcapacity/journeys/${journeyId}${!!applicantId ? `?applicantId=${applicantId}` : ''}`),
  getHouseholdTypes: ({ journeyId, applicantId }) => axios.get(`/journeys/${journeyId}/applicants/${applicantId}/household`),
  getEntityHouseholdTypes: (journeyId) => axios.get(`/journeys/${journeyId}/entity/household`),
  verifyIdentity: ({ journeyId, applicantId, body }) => axios.post(`/journeys/${journeyId}/applicants/${applicantId}/identity`, body),
  getMilestones: () => axios.get(`milestones`),
  deleteJourney: (id) => axios.delete(`/journeys/${id}`),
  createJourney: (body) => axios.post('/journeys', body),
  createAssessment: ({ body, journeyId }) => axios.post(`/journeys/${journeyId}/assessments`, body),
  signAssessment: ({ journeyId }) => axios.post(`/journeys/${journeyId}/assessment/sign`, {}),
  getJourneyAssessments: (journeyId) => axios.get(`/journeys/${journeyId}/assessments`),
  getJourneyAssessmentTemplate: (journeyId) => axios.get(`/journeys/${journeyId}/assessment/template`),
  getSMSFJourneyAssessmentTemplate: (journeyId) => axios.get(`/journeys/${journeyId}/assessment/smsfTemplate`),
  saveJourneyAssessmentTemplate: ({ journeyId, body }) => axios.put(`/journeys/${journeyId}/assessment/template`, body),
  getPreliminaryAssessment: (journeyId) => axios.get(`/journeys/${journeyId}/assessment/prelim`),
  calculatePaymentAndLmi: ({ price, deposit, rate, purpose, firstHomeBuyer }) =>
    axios.post(`/services/basicrepayments`, { price, deposit, rate, purpose, firstHomeBuyer }),
  getAssessment: (journeyId) => axios.get(`/journeys/${journeyId}/assessment`),
  getStepsListByVersion: ({ version, journeyId }) => axios.get(`/steps?version=${version}${!!journeyId ? `&journeyId=${journeyId}` : ''}`),
  calculateAssessmentParameters: ({ body, journeyId }) => axios.post(`/journeys/${journeyId}/assessment/calculate`, body),
  calculateStampDutyInJourney: ({ body, journeyId }) => axios.post(`/journeys/${journeyId}/assessment/calculateStampDuty`, body),
  getSubstatuses: () => axios.get('/dictionary/substatuses'),
  submitApplication: ({journeyId, displayIdentifier}) => axios.post('/services/nextgen/application', { journeyId, displayIdentifier }),
  archiveJourneys: ({ ids, setDatesIds }) => axios.post('/journeys/archive', { ids, setDatesIds }),
  withdrawJourney: ({ id, reason }) => axios.post('/journeys/withdraw', { id, reason }),
  getDomiumAddresses: () => axios.get('/dictionary/domiumAddresses'),
  getJourneyPayments: ({ journeyId, userId, paymentStatus, sessionStatus, product, productId }) => {
    let params = {};
    if (userId) params.user = userId;
    if (paymentStatus) params.paymentStatus = paymentStatus;
    if (sessionStatus) params.sessionStatus = sessionStatus;
    if (product) params.product = product;
    if (productId) params.productId = productId;

    return axios.request({
      url: `/journeys/${journeyId}/payments`,
      method: 'get',
      params
    });

  },
  removeConveyancingFromJourney: (journeyId) => axios.get(`/journeys/${journeyId}/removeConveyancing`),
  getJourneyFollowUps: (journeyId) => axios.get(`/journeys/${journeyId}/followUps`),
  createFollowUp: ({journeyId, body}) => axios.post(`/journeys/${journeyId}/followUps`, body),
  updateActivityOrder: ({journeyId, body}) => axios.put(`/journeys/${journeyId}/activityOrder`, body),
  deleteActivityCasesHistoryItem: ({journeyId, historyItemId}) => axios.delete(`/journeys/${journeyId}/activityCasesHistoryItem/${historyItemId}`, {}),
  getEstimatedDiscount: (journeyId) => axios.get(`/journeys/${journeyId}/estimatedDiscount`),
  requestDisbursementLetter: (journeyId) => axios.post(`/journeys/${journeyId}/requestDisbursementLetter`),
  saveContractOfSale: ({journeyId, body}) => axios.put(`/journeys/${journeyId}/contractOfSale`, body),
  getContractOfSale: (journeyId) => axios.get(`/journeys/${journeyId}/contractOfSale`),
  getCurrentScorecardsByJourney: ({journeyId, category}) => axios.get(`/scorecards/journeys/${journeyId}/current${category ? `?category=${category}` : ''}`),
  getScorecardsByJourney: (journeyId) => axios.get(`/scorecards/journeys/${journeyId}/history`),
  getScorecardById: (id) => axios.get(`/scorecards/${id}`),
  executeScorecard: (body) => axios.post(`/scorecards/execute`, body),
  cancelScorecard: (body) => axios.post(`/scorecards/cancel`, body),
  createScorecardRuleOverride: ({ journeyId, body }) => axios.post(`/scorecards/journeys/${journeyId}/rule-overrides`, body),
  createJourneyAndCopyData: (body) => axios.post(`/journeys/createAndCopyData`, body),
};

export const actionTypes = {
  GET_JOURNEYS: 'GET_JOURNEYS',
  GET_JOURNEYS_BY_ID: 'GET_JOURNEYS_BY_ID',
  GET_ALLOWED_JOURNEYS: 'GET_ALLOWED_JOURNEYS',
  GET_ALLOWED_JOURNEYS_WITH_DEBOUNCE: 'GET_ALLOWED_JOURNEYS_WITH_DEBOUNCE',
  GET_ALLOWED_JOURNEYS_BY_MILESTONES: 'GET_ALLOWED_JOURNEYS_BY_MILESTONES',
  GET_ALLOWED_JOURNEYS_BY_MILESTONES_WITH_DEBOUNCE: 'GET_ALLOWED_JOURNEYS_BY_MILESTONES_WITH_DEBOUNCE',
  GET_JOURNEY: 'GET_JOURNEY',
  UPDATE_JOURNEY: 'UPDATE_JOURNEY',
  REQUEST_DISBURSEMENT_LETTER: 'REQUEST_DISBURSEMENT_LETTER',
  GO_NEXT_JOURNEY_STEP: 'GO_NEXT_JOURNEY_STEP',
  ROLLBACK_JOURNEY_STEP: 'ROLLBACK_JOURNEY_STEP',
  GET_BORROWING_CAPACITY: 'GET_BORROWING_CAPACITY',
  GET_BORROWING_CAPACITY_FOR_SEPARATE_APPLICANTS_BULK: 'GET_BORROWING_CAPACITY_FOR_SEPARATE_APPLICANTS_BULK',
  GET_HOUSEHOLD_TYPES: 'GET_HOUSEHOLD_TYPES',
  GET_HOUSEHOLDS_TYPES: 'GET_HOUSEHOLDS_TYPES',
  GET_ENTITY_HOUSEHOLD_TYPES: 'GET_ENTITY_HOUSEHOLD_TYPES',
  VERIFY_IDENTITY: 'VERIFY_IDENTITY',
  GET_MILESTONES: 'GET_MILESTONES',
  DELETE_JOURNEY: 'DELETE_JOURNEY',
  CREATE_JOURNEY: 'CREATE_JOURNEY',
  CREATE_ASSESSMENT: 'CREATE_ASSESSMENT',
  SIGN_ASSESSMENT: 'SIGN_ASSESSMENT',
  GET_JOURNEY_ASSESSMENTS: 'GET_JOURNEY_ASSESSMENTS',
  GET_JOURNEY_ASSESSMENT_TEMPLATE: 'GET_JOURNEY_ASSESSMENT_TEMPLATE',
  GET_SMSF_JOURNEY_ASSESSMENT_TEMPLATE: 'GET_SMSF_JOURNEY_ASSESSMENT_TEMPLATE',
  SAVE_JOURNEY_ASSESSMENT_TEMPLATE: 'SAVE_JOURNEY_ASSESSMENT_TEMPLATE',
  GET_PRELIMINARY_ASSESSMENT: 'GET_PRELIMINARY_ASSESSMENT',
  CALCULATE_PAYMENT_AND_LMI: 'CALCULATE_PAYMENT_AND_LMI',
  GET_ASSESSMENT: 'GET_ASSESSMENT',
  GET_STEPS_LIST_BY_VERSION: 'GET_STEPS_LIST_BY_VERSION',
  CALCULATE_ASSESSMENT_PARAMETERS: 'CALCULATE_ASSESSMENT_PARAMETERS',
  CALCULATE_ASSESSMENT_PARAMETERS_WITH_DEBOUNCE: 'CALCULATE_ASSESSMENT_PARAMETERS_WITH_DEBOUNCE',
  CALCULATE_STAMP_DUTY_IN_JOURNEY: 'CALCULATE_STAMP_DUTY_IN_JOURNEY',
  CALCULATE_STAMP_DUTY_IN_JOURNEY_WITH_DEBOUNCE: 'CALCULATE_STAMP_DUTY_IN_JOURNEY_WITH_DEBOUNCE',
  GET_SUBSTATUSES: 'GET_SUBSTATUSES',
  SUBMIT_APPLICATION: 'SUBMIT_APPLICATION',
  ARCHIVE_JOURNEYS: 'ARCHIVE_JOURNEYS',
  WITHDRAW_JOURNEY: 'WITHDRAW_JOURNEY',
  GET_DOMIUM_ADDRESSES: 'GET_DOMIUM_ADDRESSES',
  GET_JOURNEY_PAYMENTS: 'GET_JOURNEY_PAYMENTS',
  REMOVE_CONVEYANCING_FROM_JOURNEY: 'REMOVE_CONVEYANCING_FROM_JOURNEY',
  GET_JOURNEY_FOLLOW_UPS: "GET_JOURNEY_FOLLOW_UPS",
  CREATE_FOLLOW_UP: "CREATE_FOLLOW_UP",
  UPDATE_ACTIVITY_ORDER: "UPDATE_ACTIVITY_ORDER",
  DELETE_ACTIVITY_CASES_HISTORY_ITEM: "DELETE_ACTIVITY_CASES_HISTORY_ITEM",
  GET_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND: 'GET_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND',
  START_GETTING_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND: 'START_GETTING_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND',
  STOP_GETTING_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND: 'STOP_GETTING_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND',
  GET_ESTIMATED_DISCOUNT: 'GET_ESTIMATED_DISCOUNT',
  SAVE_CONTRACT_OF_SALE: 'SAVE_CONTRACT_OF_SALE',
  GET_CONTRACT_OF_SALE: 'GET_CONTRACT_OF_SALE',
  GET_CURRENT_SCORECARDS_BY_JOURNEY: 'GET_CURRENT_SCORECARDS_BY_JOURNEY',
  GET_SCORECARDS_BY_JOURNEY: 'GET_SCORECARDS_BY_JOURNEY',
  GET_SCORECARD_BY_ID: 'GET_SCORECARD_BY_ID',
  EXECUTE_SCORECARD: 'EXECUTE_SCORECARD',
  CANCEL_SCORECARD: 'CANCEL_SCORECARD',
  CREATE_SCORECARD_RULE_OVERRIDE: 'CREATE_SCORECARD_RULE_OVERRIDE',
  START_SCORECARD_OBSERVATION: 'START_SCORECARD_OBSERVATION',
  STOP_SCORECARD_OBSERVATION: 'STOP_SCORECARD_OBSERVATION',
  START_CONTRACT_OBSERVATION: 'START_CONTRACT_OBSERVATION',
  STOP_CONTRACT_OBSERVATION: 'STOP_CONTRACT_OBSERVATION',
  CREATE_JOURNEY_AND_COPY_DATA: 'CREATE_JOURNEY_AND_COPY_DATA'
};

function* sagaGetJourneys({ payload: { userId, sort, limit, statuses, onSuccess, onError } }) {
  try {
    const { data } = yield call(Api.getJourneys, { userId, sort, limit, statuses });
    if (data.elements) {
      if (isFunc(onSuccess)) onSuccess(data);
    } else if (isFunc(onError)) onError(data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetJourneysById({ payload: { ids, onSuccess, onError } }) {
  try {
    const requests = [];
    ids.forEach((id) => requests.push(call(Api.getJourney, id)));
    const results = yield all(requests);
    if (results.every((result) => result.status < 400 || result.status === 404)) {
      if (isFunc(onSuccess)) onSuccess(results.map((result) => result.data?.id ? result.data : undefined));
    } else if (isFunc(onError)) onError();
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetAllowedJourneys({ payload: {
  limit, page, userId, search, sort, milestone, milestones, types, specialist, settlementsCoordinator, referredBy, account, reference, createdLastDays, updatedLastDays, currentStepUid, currentStepUids, statuses, invitedByUser, withTotalFormallyApprovalAmount, requestFromPartner, activities, activityFromDate, activityToDate, journeyId, allAtOnce, onSuccess, onError
} }) {
  const controller = new AbortController();
  try {
    const updMilestone = milestone === 'Settled' ? 'Settlement' : milestone;
    const updCurrentStepUid = milestone === 'Settled' ? 'settlement_completed' : (milestone === 'Settlement' && !currentStepUid ? '-settlement_completed' : currentStepUid);
    const result = yield call(Api.getAllowedJourneys, {
      limit, page, userId, search, sort, milestone: updMilestone, milestones, types, currentStepUid: updCurrentStepUid, currentStepUids, specialist, settlementsCoordinator, referredBy, account, reference, createdLastDays, updatedLastDays, statuses, invitedByUser, withTotalFormallyApprovalAmount, requestFromPartner, activities, activityFromDate, activityToDate, journeyId, allAtOnce, signal: controller.signal
    });
    if (result.data?.elements || withTotalFormallyApprovalAmount || (!!allAtOnce && result.status < 400)) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (!(yield cancelled()) && isFunc(onError)) onError();
  } finally {
    if (yield cancelled()) controller.abort();
  }
}

function* sagaGetAllowedJourneysByMilestones({ payload: { limit, userId, search, sort, milestones, statuses, specialist, settlementsCoordinator, referredBy, account, reference, onSuccess, onError } }) {
  try {
    const requests = [];
    milestones.forEach((milestone) => {
      const updMilestone = milestone === 'Settled' ? 'Settlement' : milestone;
      const currentStepUid = milestone === 'Settled' ? 'settlement_completed' : (milestone === 'Settlement' ? '-settlement_completed' : undefined);
      requests.push(call(
        Api.getAllowedJourneys,
        { limit, userId, search, sort, milestone: updMilestone, statuses, currentStepUid, specialist, settlementsCoordinator, referredBy, account, reference }
      ))
    });
    const results = yield all(requests);
    if (results.every((result) => result.status < 400)) {
      if (isFunc(onSuccess)) onSuccess(results.map((result) => result.data));
    } else if (isFunc(onError)) onError();
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetMilestones({ payload: { onSuccess, onError } }) {
  try {
    const result = yield call(Api.getMilestones);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetJourney({ payload: { id, onSuccess, onError, onUnauthorized } }) {
  try {
    const result = yield call(Api.getJourney, id);
    if (result?.data?.id) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onUnauthorized) && result?.status === 403) {
      onUnauthorized(result.data);
    } else {
      if (isFunc(onError)) onError(result.data);
    }
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaUpdateJourney({ payload: { id, body, notify, stepId, milestone, section, substatusNameStatus, metaAddress, metaDuration, metaValuationAmount, onSuccess, onError } }) {
  try {
    const result = yield call(Api.updateJourney, {id, body, notify, stepId, milestone, section, substatusNameStatus, metaAddress, metaDuration, metaValuationAmount});
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaRequestDisbursementLetter({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.requestDisbursementLetter, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaSubmitApplication({ payload: { journeyId, displayIdentifier, onSuccess, onError } }) {
  try {
    const result = yield call(Api.submitApplication, { journeyId, displayIdentifier: displayIdentifier ?? journeyId });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaCreateJourney({ payload: { body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.createJourney, body);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaCreateJourneyAndCopyData({ payload: { body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.createJourneyAndCopyData, body);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGoNextJourneyStep({ payload: { id, category, applicantId, command, notify, onSuccess, onError } }) {
  try {
    const result = yield call(Api.goNextJourneyStep, {id, category, applicantId, command, notify});
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaRollbackJourneyStep({ payload: { journeyId, category, stepId, skipConditional, onSuccess, onError } }) {
  try {
    const result = yield call(Api.rollbackJourneyStep, {journeyId, category, stepId, skipConditional});
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetBorrowingCapacity({ payload: { journeyId, applicantId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getBorrowingCapacity, { journeyId, applicantId });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetBorrowingCapacityForSeparateApplicantsBulk({ payload: { journeyId, applicantIds, onSuccess, onError } }) {
  try {
    const requests = [];
    applicantIds.forEach((applicantId) => requests.push(call(Api.getBorrowingCapacity, { journeyId, applicantId })));
    const results = yield all(requests);
    if (results.every((result) => result.status < 400 || result.status === 404)) {
      if (isFunc(onSuccess)) onSuccess(results.map((result) => result.data ? result.data : undefined));
    } else if (isFunc(onError)) onError();
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetHouseholdTypes({ payload: { journeyId, applicantId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getHouseholdTypes, { journeyId, applicantId });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetHouseholdsTypes({ payload: { journeyId, applicantsIds, onSuccess, onError } }) {
  try {
    const requests = [];
    applicantsIds.forEach((applicantId) => requests.push(call(Api.getHouseholdTypes, { journeyId, applicantId })));
    const results = yield all(requests);

    if (results.every((result) => result.status < 400)) {
      if (isFunc(onSuccess)) onSuccess(results.map((result) => result.data));
    } else if (isFunc(onError)) onError();

  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetEntityHouseholdTypes({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getEntityHouseholdTypes, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaVerifyIdentity({ payload: { journeyId, applicantId, body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.verifyIdentity, { journeyId, applicantId, body });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaDeleteJourney({ payload: { id, onSuccess, onError } }) {
  try {
    const result = yield call(Api.deleteJourney, id);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaCreateAssessment({ payload: { journeyId, body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.createAssessment, {journeyId, body});
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaSignAssessment({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.signAssessment, { journeyId });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetJourneyAssessments({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getJourneyAssessments, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetJourneyAssessmentTemplate({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getJourneyAssessmentTemplate, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetSMSFJourneyAssessmentTemplate({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getSMSFJourneyAssessmentTemplate, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaSaveJourneyAssessmentTemplate({ payload: { journeyId, body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.saveJourneyAssessmentTemplate, {journeyId, body});
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetPreliminaryAssessment({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getPreliminaryAssessment, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaCalculatePaymentAndLmi({ payload: { price, deposit, rate, purpose, firstHomeBuyer, onSuccess, onError } }) {
  try {
    const result = yield call(Api.calculatePaymentAndLmi, { price, deposit, rate, purpose, firstHomeBuyer });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetAssessment({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getAssessment, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetStepsListByVersion({ payload: { version, journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getStepsListByVersion, { version, journeyId });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaCalculateAssessmentParameters({ payload: { journeyId, body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.calculateAssessmentParameters, { journeyId, body });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaCalculateStampDutyInJourney({ payload: { journeyId, body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.calculateStampDutyInJourney, { journeyId, body });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetSubstatuses({ payload: { onSuccess, onError } }) {
  try {
    const result = yield call(Api.getSubstatuses);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetDomiumAddresses({ payload: { onSuccess, onError } }) {
  try {
    const result = yield call(Api.getDomiumAddresses);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaArchiveJourneys({ payload: { ids, setDatesIds, onSuccess, onError } }) {
  try {
    const result = yield call(Api.archiveJourneys, { ids, setDatesIds });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess();
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaWithdrawJourney({ payload: { id, reason, onSuccess, onError } }) {
  try {
    const result = yield call(Api.withdrawJourney, { id, reason });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetJourneyPayments({ payload: { journeyId, userId, paymentStatus, sessionStatus, product, productId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getJourneyPayments, { journeyId, userId, paymentStatus, sessionStatus, product, productId });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaRemoveConveyancingFromJourney({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const { data } = yield call(Api.removeConveyancingFromJourney, journeyId);
    if (data) {
      if (isFunc(onSuccess)) onSuccess(data);
    } else if (isFunc(onError)) onError(data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetJourneyFollowUps({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getJourneyFollowUps, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaCreateFollowUp({ payload: { journeyId, body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.createFollowUp, {journeyId, body});
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaUpdateActivityOrder({ payload: { journeyId, body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.updateActivityOrder, {journeyId, body});
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaDeleteActivityCasesHistoryItem({ payload: { journeyId, historyItemId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.deleteActivityCasesHistoryItem, {journeyId, historyItemId});
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetEstimatedDiscount({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getEstimatedDiscount, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaSaveContractOfSale({ payload: { journeyId, body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.saveContractOfSale, {journeyId, body});
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetContractOfSale({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getContractOfSale, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetCurrentScorecardsByJourney({ payload: { journeyId, category, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getCurrentScorecardsByJourney, { journeyId, category });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetScorecardsByJourney({ payload: { journeyId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getScorecardsByJourney, journeyId);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaGetScorecardById({ payload: { id, onSuccess, onError } }) {
  try {
    const result = yield call(Api.getScorecardById, id);
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaExecuteScorecard({ payload: { journeyId, category, stepId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.executeScorecard, { journeyId, category, stepId });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaCancelScorecard({ payload: { jobId, onSuccess, onError } }) {
  try {
    const result = yield call(Api.cancelScorecard, { jobId });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

function* sagaCreateScorecardRuleOverride({ payload: { journeyId, body, onSuccess, onError } }) {
  try {
    const result = yield call(Api.createScorecardRuleOverride, { journeyId, body });
    if (result.status < 400) {
      if (isFunc(onSuccess)) onSuccess(result.data);
    } else if (isFunc(onError)) onError(result.data);
  } catch {
    if (isFunc(onError)) onError();
  }
}

//websockets - begin
async function websocketUpdatedJourneysActivityInitChannel() {
  const accessToken = localStorage.getItem('X-ACCESS-TOKEN'); // eslint-disable-line
  wsUpdatedJourneysObserver = new WebSocket(`${config.API_WS_URL}/updatedJourneysActivityObservation`, accessToken || '');

  return eventChannel(emit => {
    wsUpdatedJourneysObserver.onmessage = e => {
      const data = JSON.parse(e.data);

      console.log(`Got message from "updatedJourneysActivityObservation" WS:`, data);

      if (data.message) {
        console.log(`Message from "updatedJourneysObservation" websocket:`, data.message );
      } else {
        emit({
          type: journeysActionTypes.PUSH_TO_UPDATED_JOURNEYS_ACTIVITY_QUEUE,
          payload: data
        });
      }
    };

    wsUpdatedJourneysObserver.onerror = error => {
      console.error(`Websocket connection with "updatedJourneysObservation" failed:`, error);
    };

    wsUpdatedJourneysObserver.onclose = () => {
      if (!shouldUpdatedJourneysObserverBeTerminated) {
        setTimeout(
          function () {
            emit({ type: 'CONNECTION_CLOSED' });
          },
          config.isLocalhost ? 500 : 500
        );
      }
    };

    return () => {
      wsUpdatedJourneysObserver.close();
    };
  });
}

function* websocketUpdatedJourneysActivitySaga() {
  function* bgSync() {
    shouldUpdatedJourneysObserverBeTerminated = false;
    let channel = yield call(websocketUpdatedJourneysActivityInitChannel);
    try {
      while (true) {
        const action = yield take(channel);
        if (action.type === 'CONNECTION_CLOSED') {
          if (!shouldUpdatedJourneysObserverBeTerminated) channel = yield call(websocketUpdatedJourneysActivityInitChannel);
        } else {
          yield put(action);
        }
      }
    } finally {
      shouldUpdatedJourneysObserverBeTerminated = true;
      channel.close();
    }
  }

  while (yield take(actionTypes.START_GETTING_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND)) {
    const bgSyncTask = yield fork(() => bgSync());

    yield take(actionTypes.STOP_GETTING_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND);

    yield cancel(bgSyncTask);
  }
}

async function websocketScorecardInitChannel(journeyId, isReconnect = false) {
  const accessToken = localStorage.getItem('X-ACCESS-TOKEN'); // eslint-disable-line
  wsScorecardObserver = new WebSocket(`${config.API_WS_URL}/scorecardObservation?journeyId=${journeyId}`, accessToken || '');

  return eventChannel(emit => {
    wsScorecardObserver.onopen = () => {
      if (isReconnect) {
        emit({ type: journeysActionTypes.SCORECARD_CONNECTION_RESTORED, payload: Date.now() });
      }
    };

    wsScorecardObserver.onmessage = e => {
      const data = JSON.parse(e.data);
      if (!data.message) {
        //console.log('Scorecard broadcast:', data);
        emit({ type: journeysActionTypes.SCORECARD_PUSH_UPDATE, payload: data });
      }
    };

    wsScorecardObserver.onerror = error => {
      console.error('Websocket connection with "scorecardObservation" failed:', error);
    };

    wsScorecardObserver.onclose = () => {
      if (!shouldScorecardObserverBeTerminated) {
        setTimeout(() => {
          emit({ type: 'SCORECARD_CONNECTION_CLOSED' });
        }, 500);
      }
    };

    return () => {
      wsScorecardObserver.close();
    };
  });
}

function* websocketScorecardSaga({ payload: { journeyId } }) {
  function* bgSync() {
    shouldScorecardObserverBeTerminated = false;
    let channel = yield call(websocketScorecardInitChannel, journeyId);
    try {
      while (true) {
        const action = yield take(channel);
        if (action.type === 'SCORECARD_CONNECTION_CLOSED') {
          if (!shouldScorecardObserverBeTerminated) channel = yield call(websocketScorecardInitChannel, journeyId, true);
        } else {
          yield put(action);
        }
      }
    } finally {
      shouldScorecardObserverBeTerminated = true;
      channel.close();
    }
  }

  const bgSyncTask = yield fork(() => bgSync());
  yield take(actionTypes.STOP_SCORECARD_OBSERVATION);
  yield cancel(bgSyncTask);
}

async function websocketContractInitChannel(journeyId) {
  const accessToken = localStorage.getItem('X-ACCESS-TOKEN'); // eslint-disable-line
  wsContractObserver = new WebSocket(`${config.API_WS_URL}/contractObservation?journeyId=${journeyId}`, accessToken || '');

  return eventChannel(emit => {
    wsContractObserver.onmessage = e => {
      const data = JSON.parse(e.data);
      if (!data.message) {
        emit({ type: journeysActionTypes.CONTRACT_PUSH_UPDATE, payload: data });
      }
    };

    wsContractObserver.onerror = error => {
      console.error('Websocket connection with "contractObservation" failed:', error);
    };

    wsContractObserver.onclose = () => {
      if (!shouldContractObserverBeTerminated) {
        setTimeout(() => {
          emit({ type: 'CONTRACT_CONNECTION_CLOSED' });
        }, 500);
      }
    };

    return () => {
      wsContractObserver.close();
    };
  });
}

function* websocketContractSaga({ payload: { journeyId } }) {
  function* bgSync() {
    shouldContractObserverBeTerminated = false;
    let channel = yield call(websocketContractInitChannel, journeyId);
    try {
      while (true) {
        const action = yield take(channel);
        if (action.type === 'CONTRACT_CONNECTION_CLOSED') {
          if (!shouldContractObserverBeTerminated) channel = yield call(websocketContractInitChannel, journeyId);
        } else {
          yield put(action);
        }
      }
    } finally {
      shouldContractObserverBeTerminated = true;
      channel.close();
    }
  }

  const bgSyncTask = yield fork(() => bgSync());
  yield take(actionTypes.STOP_CONTRACT_OBSERVATION);
  yield cancel(bgSyncTask);
}

//websockets - end

export const getJourneys = payload => ({ type: actionTypes.GET_JOURNEYS, payload });
export const getJourneysById = payload => ({ type: actionTypes.GET_JOURNEYS_BY_ID, payload });
export const getJourney = payload => ({ type: actionTypes.GET_JOURNEY, payload });
export const updateJourney = payload => ({ type: actionTypes.UPDATE_JOURNEY, payload });
export const requestDisbursementLetter = payload => ({ type: actionTypes.REQUEST_DISBURSEMENT_LETTER, payload });
export const goNextJourneyStep = payload => ({ type: actionTypes.GO_NEXT_JOURNEY_STEP, payload });
export const rollbackJourneyStep = payload => ({ type: actionTypes.ROLLBACK_JOURNEY_STEP, payload });
export const getBorrowingCapacity = payload => ({ type: actionTypes.GET_BORROWING_CAPACITY, payload });
export const getBorrowingCapacityForSeparateApplicantsBulk = payload => ({ type: actionTypes.GET_BORROWING_CAPACITY_FOR_SEPARATE_APPLICANTS_BULK, payload });
export const getHouseholdTypes = payload => ({ type: actionTypes.GET_HOUSEHOLD_TYPES, payload });
export const getHouseholdsTypes = payload => ({ type: actionTypes.GET_HOUSEHOLDS_TYPES, payload });
export const getEntityHouseholdTypes = payload => ({ type: actionTypes.GET_ENTITY_HOUSEHOLD_TYPES, payload });
export const verifyIdentity = payload => ({ type: actionTypes.VERIFY_IDENTITY, payload });
export const getAllowedJourneys = payload => ({ type: actionTypes.GET_ALLOWED_JOURNEYS, payload });
export const getAllowedJourneysWithDebounce = payload => ({ type: actionTypes.GET_ALLOWED_JOURNEYS_WITH_DEBOUNCE, payload });
export const getAllowedJourneysByMilestones = payload => ({ type: actionTypes.GET_ALLOWED_JOURNEYS_BY_MILESTONES, payload });
export const getAllowedJourneysByMilestonesWithDebounce = payload => ({ type: actionTypes.GET_ALLOWED_JOURNEYS_BY_MILESTONES_WITH_DEBOUNCE, payload });
export const getMilestones = payload => ({ type: actionTypes.GET_MILESTONES, payload });
export const deleteJourney = payload => ({ type: actionTypes.DELETE_JOURNEY, payload });
export const createJourney = payload => ({ type: actionTypes.CREATE_JOURNEY, payload });
export const createJourneyAndCopyData = payload => ({ type: actionTypes.CREATE_JOURNEY_AND_COPY_DATA, payload });
export const createAssessment = payload => ({ type: actionTypes.CREATE_ASSESSMENT, payload });
export const signAssessment = payload => ({ type: actionTypes.SIGN_ASSESSMENT, payload });
export const getJourneyAssessments = payload => ({ type: actionTypes.GET_JOURNEY_ASSESSMENTS, payload });
export const getJourneyAssessmentTemplate = payload => ({ type: actionTypes.GET_JOURNEY_ASSESSMENT_TEMPLATE, payload });
export const getSMSFJourneyAssessmentTemplate = payload => ({ type: actionTypes.GET_SMSF_JOURNEY_ASSESSMENT_TEMPLATE, payload });
export const saveJourneyAssessmentTemplate = payload => ({ type: actionTypes.SAVE_JOURNEY_ASSESSMENT_TEMPLATE, payload });
export const getPreliminaryAssessment = payload => ({ type: actionTypes.GET_PRELIMINARY_ASSESSMENT, payload });
export const calculatePaymentAndLmi = payload => ({ type: actionTypes.CALCULATE_PAYMENT_AND_LMI, payload });
export const getAssessment = payload => ({ type: actionTypes.GET_ASSESSMENT, payload });
export const getStepsListByVersion = payload => ({ type: actionTypes.GET_STEPS_LIST_BY_VERSION, payload });
export const calculateAssessmentParameters = payload => ({ type: actionTypes.CALCULATE_ASSESSMENT_PARAMETERS, payload });
export const calculateAssessmentParametersWithDebounce = payload => ({ type: actionTypes.CALCULATE_ASSESSMENT_PARAMETERS_WITH_DEBOUNCE, payload });
export const calculateStampDutyInJourney = payload => ({ type: actionTypes.CALCULATE_STAMP_DUTY_IN_JOURNEY, payload });
export const calculateStampDutyInJourneyWithDebounce = payload => ({ type: actionTypes.CALCULATE_STAMP_DUTY_IN_JOURNEY_WITH_DEBOUNCE, payload });
export const getSubstatuses = payload => ({ type: actionTypes.GET_SUBSTATUSES, payload });
export const submitApplication = payload => ({ type: actionTypes.SUBMIT_APPLICATION, payload });
export const archiveJourneys = payload => ({ type: actionTypes.ARCHIVE_JOURNEYS, payload });
export const withdrawJourney = payload => ({ type: actionTypes.WITHDRAW_JOURNEY, payload });
export const getDomiumAddresses = payload => ({ type: actionTypes.GET_DOMIUM_ADDRESSES, payload });
export const getJourneyPayments = payload => ({ type: actionTypes.GET_JOURNEY_PAYMENTS, payload });
export const removeConveyancingFromJourney = payload => ({ type: actionTypes.REMOVE_CONVEYANCING_FROM_JOURNEY, payload });
export const getJourneyFollowUps = payload => ({ type: actionTypes.GET_JOURNEY_FOLLOW_UPS, payload });
export const createFollowUp = payload => ({ type: actionTypes.CREATE_FOLLOW_UP, payload });
export const updateActivityOrder = payload => ({ type: actionTypes.UPDATE_ACTIVITY_ORDER, payload });
export const deleteActivityCasesHistoryItem = payload => ({ type: actionTypes.DELETE_ACTIVITY_CASES_HISTORY_ITEM, payload });
export const getJourneysUpdatesInBackground = payload => ({ type: actionTypes.GET_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND, payload });
export const startGettingJourneysUpdatesInBackground = () => ({ type: actionTypes.START_GETTING_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND });
export const stopGettingJourneysUpdatesInBackground = () => ({ type: actionTypes.STOP_GETTING_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND });
export const getEstimatedDiscount = payload => ({ type: actionTypes.GET_ESTIMATED_DISCOUNT, payload });
export const saveContractOfSale = payload => ({ type: actionTypes.SAVE_CONTRACT_OF_SALE, payload });
export const getContractOfSale = payload => ({ type: actionTypes.GET_CONTRACT_OF_SALE, payload });
export const getCurrentScorecardsByJourney = payload => ({ type: actionTypes.GET_CURRENT_SCORECARDS_BY_JOURNEY, payload });
export const getScorecardsByJourney = payload => ({ type: actionTypes.GET_SCORECARDS_BY_JOURNEY, payload });
export const getScorecardById = payload => ({ type: actionTypes.GET_SCORECARD_BY_ID, payload });
export const executeScorecard = payload => ({ type: actionTypes.EXECUTE_SCORECARD, payload });
export const cancelScorecard = payload => ({ type: actionTypes.CANCEL_SCORECARD, payload });
export const createScorecardRuleOverride = payload => ({ type: actionTypes.CREATE_SCORECARD_RULE_OVERRIDE, payload });
export const startScorecardObservation = payload => ({ type: actionTypes.START_SCORECARD_OBSERVATION, payload });
export const stopScorecardObservation = () => ({ type: actionTypes.STOP_SCORECARD_OBSERVATION });
export const startContractObservation = payload => ({ type: actionTypes.START_CONTRACT_OBSERVATION, payload });
export const stopContractObservation = () => ({ type: actionTypes.STOP_CONTRACT_OBSERVATION });

const journeysSagas = [
  takeEvery(actionTypes.GET_JOURNEY, sagaGetJourney),
  takeEvery(actionTypes.GET_JOURNEYS, sagaGetJourneys),
  takeEvery(actionTypes.GET_JOURNEYS_BY_ID, sagaGetJourneysById),
  takeEvery(actionTypes.UPDATE_JOURNEY, sagaUpdateJourney),
  takeEvery(actionTypes.REQUEST_DISBURSEMENT_LETTER, sagaRequestDisbursementLetter),
  takeEvery(actionTypes.GO_NEXT_JOURNEY_STEP, sagaGoNextJourneyStep),
  takeEvery(actionTypes.ROLLBACK_JOURNEY_STEP, sagaRollbackJourneyStep),
  takeLatest(actionTypes.GET_BORROWING_CAPACITY, sagaGetBorrowingCapacity),
  takeLatest(actionTypes.GET_BORROWING_CAPACITY_FOR_SEPARATE_APPLICANTS_BULK, sagaGetBorrowingCapacityForSeparateApplicantsBulk),
  takeLatest(actionTypes.GET_HOUSEHOLD_TYPES, sagaGetHouseholdTypes),
  takeLatest(actionTypes.GET_HOUSEHOLDS_TYPES, sagaGetHouseholdsTypes),
  takeLatest(actionTypes.GET_ENTITY_HOUSEHOLD_TYPES, sagaGetEntityHouseholdTypes),
  takeEvery(actionTypes.VERIFY_IDENTITY, sagaVerifyIdentity),
  takeLatest(actionTypes.GET_ALLOWED_JOURNEYS_WITH_DEBOUNCE, function* (action) {
    yield delay(300);
    yield call(sagaGetAllowedJourneys, action);
  }),
  takeLatest(actionTypes.GET_ALLOWED_JOURNEYS_BY_MILESTONES, sagaGetAllowedJourneysByMilestones),
  debounce(500, actionTypes.GET_ALLOWED_JOURNEYS_BY_MILESTONES_WITH_DEBOUNCE, sagaGetAllowedJourneysByMilestones),
  takeEvery(actionTypes.GET_ALLOWED_JOURNEYS, sagaGetAllowedJourneys),
  takeLatest(actionTypes.GET_MILESTONES, sagaGetMilestones),
  takeLeading(actionTypes.DELETE_JOURNEY, sagaDeleteJourney),
  takeEvery(actionTypes.CREATE_JOURNEY, sagaCreateJourney),
  takeEvery(actionTypes.CREATE_JOURNEY_AND_COPY_DATA, sagaCreateJourneyAndCopyData),
  takeEvery(actionTypes.CREATE_ASSESSMENT, sagaCreateAssessment),
  takeEvery(actionTypes.SIGN_ASSESSMENT, sagaSignAssessment),
  takeEvery(actionTypes.GET_JOURNEY_ASSESSMENTS, sagaGetJourneyAssessments),
  takeLatest(actionTypes.GET_JOURNEY_ASSESSMENT_TEMPLATE, sagaGetJourneyAssessmentTemplate),
  takeLatest(actionTypes.GET_SMSF_JOURNEY_ASSESSMENT_TEMPLATE, sagaGetSMSFJourneyAssessmentTemplate),
  takeEvery(actionTypes.SAVE_JOURNEY_ASSESSMENT_TEMPLATE, sagaSaveJourneyAssessmentTemplate),
  takeLatest(actionTypes.GET_PRELIMINARY_ASSESSMENT, sagaGetPreliminaryAssessment),
  takeLatest(actionTypes.CALCULATE_PAYMENT_AND_LMI, sagaCalculatePaymentAndLmi),
  takeLatest(actionTypes.GET_ASSESSMENT, sagaGetAssessment),
  takeLatest(actionTypes.GET_STEPS_LIST_BY_VERSION, sagaGetStepsListByVersion),
  takeLatest(actionTypes.CALCULATE_ASSESSMENT_PARAMETERS, sagaCalculateAssessmentParameters),
  debounce(900, actionTypes.CALCULATE_ASSESSMENT_PARAMETERS_WITH_DEBOUNCE, sagaCalculateAssessmentParameters),
  takeLatest(actionTypes.CALCULATE_STAMP_DUTY_IN_JOURNEY, sagaCalculateStampDutyInJourney),
  debounce(900, actionTypes.CALCULATE_STAMP_DUTY_IN_JOURNEY_WITH_DEBOUNCE, sagaCalculateStampDutyInJourney),
  takeLatest(actionTypes.GET_SUBSTATUSES, sagaGetSubstatuses),
  takeLatest(actionTypes.SUBMIT_APPLICATION, sagaSubmitApplication),
  takeEvery(actionTypes.ARCHIVE_JOURNEYS, sagaArchiveJourneys),
  takeEvery(actionTypes.WITHDRAW_JOURNEY, sagaWithdrawJourney),
  takeLatest(actionTypes.GET_DOMIUM_ADDRESSES, sagaGetDomiumAddresses),
  takeLatest(actionTypes.GET_JOURNEY_PAYMENTS, sagaGetJourneyPayments),
  takeLeading(actionTypes.REMOVE_CONVEYANCING_FROM_JOURNEY, sagaRemoveConveyancingFromJourney),
  takeLatest(actionTypes.GET_JOURNEY_FOLLOW_UPS, sagaGetJourneyFollowUps),
  takeEvery(actionTypes.CREATE_FOLLOW_UP, sagaCreateFollowUp),
  debounce(33, actionTypes.UPDATE_ACTIVITY_ORDER, sagaUpdateActivityOrder),
  debounce(33, actionTypes.DELETE_ACTIVITY_CASES_HISTORY_ITEM, sagaDeleteActivityCasesHistoryItem),
  takeLatest(actionTypes.GET_JOURNEYS_ACTIVITY_UPDATES_IN_BACKGROUND, websocketUpdatedJourneysActivitySaga),
  takeLatest(actionTypes.GET_ESTIMATED_DISCOUNT, sagaGetEstimatedDiscount),
  takeEvery(actionTypes.SAVE_CONTRACT_OF_SALE, sagaSaveContractOfSale),
  takeLatest(actionTypes.GET_CONTRACT_OF_SALE, sagaGetContractOfSale),
  takeLatest(actionTypes.GET_CURRENT_SCORECARDS_BY_JOURNEY, sagaGetCurrentScorecardsByJourney),
  takeLatest(actionTypes.GET_SCORECARDS_BY_JOURNEY, sagaGetScorecardsByJourney),
  takeLatest(actionTypes.GET_SCORECARD_BY_ID, sagaGetScorecardById),
  takeEvery(actionTypes.EXECUTE_SCORECARD, sagaExecuteScorecard),
  takeLeading(actionTypes.CANCEL_SCORECARD, sagaCancelScorecard),
  takeEvery(actionTypes.CREATE_SCORECARD_RULE_OVERRIDE, sagaCreateScorecardRuleOverride),
  takeLatest(actionTypes.START_SCORECARD_OBSERVATION, websocketScorecardSaga),
  takeLatest(actionTypes.START_CONTRACT_OBSERVATION, websocketContractSaga),
];

export default journeysSagas;
